import Box from "ds/components/Box";
import AssistantPanelContent from "components/AssistantPanel/Content";
import useAssistantPanelRunningChatBlocker from "components/AssistantPanel/Chat/hooks/useRunningChatBlocker";
import { ASSISTANT_PANEL_CONTAINER } from "components/AssistantPanel/Layout/constants";
import { useContainerSizeObserver } from "hooks/useContainerBreakpoint";
import useTitle from "hooks/useTitle";

import styles from "./styles.module.css";

const AssistantPage = () => {
  useTitle("Infra Assistant");
  useAssistantPanelRunningChatBlocker();

  const { setRef } = useContainerSizeObserver(ASSISTANT_PANEL_CONTAINER);

  return (
    <Box ref={setRef} direction="column" grow="1" fullHeight className={styles.wrapper}>
      <AssistantPanelContent />
    </Box>
  );
};

export default AssistantPage;
